import TripPanelFilter from "./TripPanelFilter"

export default  TripPanelFilter;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelFilter/index.js